import React, { useState } from "react";
import { api } from "@/lib/api";
import { PlayCircle } from "lucide-react";

export default function RecordingButton({ callId, testid }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const onPlay = async () => {
    if (url || loading) return;
    setLoading(true);
    try {
      const res = await api.get(`/twilio/recording/${callId}`, { responseType: "blob" });
      setUrl(URL.createObjectURL(res.data));
    } catch (e) {
      console.error(e);
      alert(e.response?.status === 403 ? "Only the company owner may listen to recordings" : "Could not load recording");
    } finally { setLoading(false); }
  };

  if (url) {
    return <audio data-testid={`${testid}-audio`} src={url} controls className="inline-block align-middle h-8 max-w-[200px]" autoPlay />;
  }

  return (
    <button
      data-testid={testid}
      onClick={onPlay}
      disabled={loading}
      title="Play recording"
      className="inline-flex items-center gap-1 px-2 py-1 text-emerald-700 hover:text-emerald-900 bg-emerald-50 hover:bg-emerald-100 rounded text-xs font-semibold disabled:opacity-50"
    >
      <PlayCircle className="w-3.5 h-3.5" /> {loading ? "..." : "Play"}
    </button>
  );
}
